import "@babel/polyfill";
import React, { Component } from "react";
import { render } from "react-dom";

import Header from "./templates/layout/Header";
import Home from "./templates/pages/Home";
//import Footer from "./templates/layout/Footer";

import "./stylesheets/index.scss";

export default class Warrant extends Component {
    constructor() {
        super();
        this.state = {
            authorized: false
        };
    }
    componentDidMount() {
        if (window.location.pathname.toLowerCase() !== "/justtemplates") {
            this.setState({ authorized: true });
        }
    }
    render() {
        return (
            <div>
                <Header authorized={this.state.authorized}/>
                <Home authorized={this.state.authorized}/>
            </div>
        );
    }
}

render(<Warrant />, document.getElementById("app"));